// extracted by mini-css-extract-plugin
module.exports = {"slide":"BaseSteps_slide_14EmP","slide-reverse":"BaseSteps_slide-reverse_Ljgar"};